import React from "react";

const NotFoundPage = () => {
  return <h2>Page Not Found, Go Back To Safety</h2>;
};

export default NotFoundPage;
